/* =========================================================
   Sopora — predictive search
   Header search icon opens an overlay with live product /
   collection / page suggestions via the Predictive Search API.
   ========================================================= */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-predictive-input]');
  var resultsEl = overlay.querySelector('[data-predictive-results]');
  var form = overlay.querySelector('[data-predictive-form]');
  var searchRoot = (window.SoporaCart && window.SoporaCart.routes && window.SoporaCart.routes.search) || '/search';
  var lastFocus = null;
  var debounce;

  function open() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 20);
  }
  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    resultsEl.innerHTML = '';
    if (lastFocus) lastFocus.focus();
  }

  function money(cents) {
    var cfg = window.SoporaCart || {};
    var fmt = cfg.moneyFormat || '${{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, function (m, nd) { return nd ? whole : whole + '.' + parts[1]; });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function render(data, term) {
    var r = data.resources.results;
    var html = '';
    if (r.products && r.products.length) {
      html += '<div class="predictive__group-title">Products</div>';
      html += r.products.map(function (p) {
        var img = (p.image || (p.featured_image && p.featured_image.url)) || '';
        var price = p.price ? money(parseInt(p.price, 10)) : '';
        return '<a class="predictive__item predictive__link" href="' + encodeURI(p.url) + '">' +
          (img ? '<img class="predictive__thumb" src="' + encodeURI(img) + '" alt="" loading="lazy">' : '<span class="predictive__thumb"></span>') +
          '<span><span class="predictive__title">' + esc(p.title) + '</span>' + (price ? '<span class="predictive__meta"> ' + price + '</span>' : '') + '</span></a>';
      }).join('');
    }
    if (r.collections && r.collections.length) {
      html += '<div class="predictive__group-title">Collections</div>';
      html += r.collections.map(function (c) {
        return '<a class="predictive__item" href="' + encodeURI(c.url) + '"><span class="predictive__title">' + esc(c.title) + '</span></a>';
      }).join('');
    }
    if (r.pages && r.pages.length) {
      html += '<div class="predictive__group-title">Pages</div>';
      html += r.pages.map(function (pg) {
        return '<a class="predictive__item" href="' + encodeURI(pg.url) + '"><span class="predictive__meta">' + esc(pg.title) + '</span></a>';
      }).join('');
    }
    if (!html) { resultsEl.innerHTML = '<p class="predictive__empty">No matches for "' + esc(term) + '". Press enter to search everything.</p>'; return; }
    html += '<a class="predictive__all" href="' + searchRoot + '?q=' + encodeURIComponent(term) + '&type=product">See all results &rarr;</a>';
    resultsEl.innerHTML = html;
  }

  function query(term) {
    var url = searchRoot + '/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data, term); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(debounce);
    if (term.length < 2) { resultsEl.innerHTML = ''; return; }
    debounce = setTimeout(function () { query(term); }, 200);
  });

  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });

  // Open from any header search trigger
  document.querySelectorAll('[data-search-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
})();
